import { render, staticRenderFns } from "./monthMBForm.vue?vue&type=template&id=6d8ab426&scoped=true&"
import script from "./monthMBForm.vue?vue&type=script&lang=js&"
export * from "./monthMBForm.vue?vue&type=script&lang=js&"
import style0 from "./monthMBForm.vue?vue&type=style&index=0&id=6d8ab426&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d8ab426",
  null
  
)

export default component.exports